const Alert = ({ message, type, closeAlert }) => (
  <div
    className="alert-hitfit"
    style={{
      position: "fixed",
      top: "10px",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: "10000",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
      padding: "14px 25px",
      // Global reset in tooplate-infinite-loop.css (`* { height: 100% }`) applies to any
      // element without its own explicit `height` — since this is position:fixed, that
      // stretched the box to the full viewport height. `height: "auto"` overrides it so the
      // box only grows to fit its padding + text, however many lines that wraps to.
      height: "auto",
      width: "min(500px, calc(100vw - 32px))",
      minWidth: "min(300px, calc(100vw - 32px))",
      textAlign: "center",
      backgroundColor:
        type === "success"
          ? "#4caf50" // Green for success
          : type === "error"
          ? "#f44336" // Red for error
          : "rgb(151, 223, 255)", // Blue for info
      color: "white",
      fontWeight: "bold",
      lineHeight: 1.4,
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    }}
  >
    {message}
  </div>
);

export default Alert;
